import React, { FC, useEffect } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import Breadcrumbs from '../../components/breadcrumbs';
import InfoList from '../../components/infoList';
import pageWrapper from '../../hoc/pageWrapper';
import IOpeningHours from '../../interfaces/openingHours/openingHours';

interface Props {
	componentId: number;
	page: IOpeningHours;
}

const OpeningHours: FC<Props> = ({ page }) => {
	return (
		<ContainerLarge>
			<Breadcrumbs pageId={page.Id} />
			<InfoList page={page} />
		</ContainerLarge>
	);
};

export default pageWrapper(OpeningHours);
